/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetOrderResponseDataTravelDocumentsInnerPrice } from './getOrderResponseDataTravelDocumentsInnerPrice';
import { GetOrderResponseDataTravelDocumentsInnerReasonForIssuance } from './getOrderResponseDataTravelDocumentsInnerReasonForIssuance';
import { GetOrderResponseDataTravelDocumentsInnerPaymentTransactionsInner } from './getOrderResponseDataTravelDocumentsInnerPaymentTransactionsInner';
import { GetOrderResponseDataTravelDocumentsInnerFareInfosInner } from './getOrderResponseDataTravelDocumentsInnerFareInfosInner';

export interface GetOrderResponseDataTravelDocumentsInner {
  /**
   * 番号
   */
  id?: string;
  /**
   * ドキュメント種別<br/> eticket：航空券<br/> services：EMD\"
   */
  documentType?: GetOrderResponseDataTravelDocumentsInner.DocumentTypeEnum;
  /**
   * FAエレメントであるか<br/> FAエレメントである場合true<br/> ※falseの場合はドキュメント種別が航空券だとFHE、EMDだとFHDとなる。
   */
  areCouponsAndSegmentsInSync?: boolean;
  /**
   * 航空券のステータス<br/> DxAPIから返却されたステータスをそのまま返却する。<br/> ※ FAエレメントのステータス(FA ETの「T」など)を基にDxAPIが返却する文字列。例：ISSUED<br/> ※ドキュメント種別が航空券の場合のみ返却する。
   */
  status?: string;
  /**
   * リレート先セグメントIDリスト<br/> ドキュメント種別が航空券の場合、DxAPIから返却されたセグメントIDをそのままそのまま返却する。<br/> ドキュメント種別がEMDの場合、サービスID(どのSSRに紐づくかのID)をもとにサービス情報を参照し、その中のリレート先セグメントIDを返却する。
   */
  flightIds?: Array<string>;
  /**
   * リレート先搭乗者リスト
   */
  travelerIds?: Array<string>;
  /**
   * リレート先サービスリスト<br/> ※ ドキュメント種別がEMDの場合のみ返却する。
   */
  serviceIds?: Array<string>;
  price?: GetOrderResponseDataTravelDocumentsInnerPrice;
  /**
   * そのレコードで行われた支払いトランザクションリスト
   */
  paymentTransactions?: Array<GetOrderResponseDataTravelDocumentsInnerPaymentTransactionsInner>;
  /**
   * 運賃・サービス料金情報
   */
  fareInfos?: Array<GetOrderResponseDataTravelDocumentsInnerFareInfosInner>;
  reasonForIssuance?: GetOrderResponseDataTravelDocumentsInnerReasonForIssuance;
  /**
   * 取消EMD運用区分<br/> 有料サービス情報を表すコードを基にASWDB(マスタ)から取得した以下の値を設定する。<br/> 0:再利用<br/> 1:払戻
   */
  cancelledEmdOperationType?: string;
  /**
   * 有料サービス情報を表すコード<br/> 発行事由のサブコードを基にASWDB(マスタ)から取得したAncillaryコードを設定する。<br/> ※Ancillaryコードには、DxAPIより返却されたSSRコードを統合したものが定義される。
   */
  ancillaryCode?: string;
  /**
   * 未使用のクーポンステータスが含まれるか<br/> 1つでも未使用EMDクーポンステータス(設定ファイルに定義)が含まれる場合true
   */
  hasUnusedCoupon?: boolean;
}
export namespace GetOrderResponseDataTravelDocumentsInner {
  export type DocumentTypeEnum = 'eticket' | 'services';
  export const DocumentTypeEnum = {
    Eticket: 'eticket' as DocumentTypeEnum,
    Services: 'services' as DocumentTypeEnum,
  };
}
